export const fabricColors = {
	"black": "#262E33",
	"blue01": "#65C9FF",
	"blue02": "#5199E4",
	"blue03": "#25557C",
	"gray01": "#E6E6E6",
	"gray02": "#929598",
	"heather": "#3C4F5C",
	"pastelBlue": "#B1E2FF",
	"pastelGreen": "#A7FFC4",
	"pastelOrange": "#FFDEB5",
	"pastelRed": "#FFAFB9",
	"pastelYellow": "#FFFFB1",
	"pink": "#FF488E",
	"red": "#FF5C5C",
	"yellow": "#e3c33a",
	"green": "#34c339",
	"brown": "#724133",
	"brownDark": "#4A312C",
	"white": "#F4F4F4",
};

export const hairColors = {
	"auburn": "#A55728",
	"black": "#2C1B18",
	"blonde": "#B58143",
	"blondeGolden": "#D6B370",
	"brown": "#724133",
	"brownDark": "#4A312C",
	"platinum": "#ECDCBF",
	"red": "#C93305",
};

export const skinColors = {
	"tanned": "#FD9841",
	"yellow": "#F8D25C",
	"pale": "#FFDBB4",
	"light": "#EDB98A",
	"brown": "#D08B5B",
	"dark-brown": "#AE5D29",
	"black": "#614335",
};



// WEBPACK FOOTER //
// ./src/colors.js